<div id="basemodal-{{randomId}}" class="basemodal">
  <div class="modalcontent">
    <div class="modalbody">
      <button class="closemodal-btn" (click)="close()" *ngIf="allowClose"><i class="material-icons delete-icon">highlight_off</i></button>
      <ng-template #modalcontainer></ng-template>
    </div>
  </div>
  <div class="modalbackground"></div>
</div>